import { render, staticRenderFns } from "./CiCaseDetailModal.vue?vue&type=template&id=35f9e28e"
import script from "./CiCaseDetailModal.vue?vue&type=script&lang=js"
export * from "./CiCaseDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports